import Auth from '../../modules/Authentication'
import { apiUrl } from '../../variables/index'
import { handleErrors, handleResponse } from '../../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Suppliers {
  auth = new Auth()
  create = member => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}suppliers/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(member),
    }).then(handleErrors)
  }
  list = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}suppliers/`, { headers })
      .then(handleErrors)
      .then(handleResponse)
  }

  get = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}suppliers/${key}`, { headers }).then(handleErrors)
  }
  getMember = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}suppliers/${key}/member`, { headers })
      .then(handleErrors)
      .then(handleResponse)
  }
  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}suppliers/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }

  remove = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}suppliers/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  permissions = {
    list: (key, org) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/permissions/${org}`, {
        headers,
      }).then(handleErrors)
    },
    update: (key, org, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/permissions/${org}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  banks = {
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/banks/`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  contracts = {
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/contracts/`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  requisitions = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}labourreqs/`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
  registrations = {
    list: () => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/registrations/`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    },
    get: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/registrations/${key}`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    },
    approve: data => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/registrations/approve`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: data => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}/suppliers/registrations/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: data => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/registrations/delete`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    create: data => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}/suppliers/registrations/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      }).then(handleErrors)
    },
  }
  files = {
    list: key => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/files/`, { headers })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (key, bankID, data) => {
      headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
      return fetch(`${apiUrl}suppliers/${key}/banks/${bankID}`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  }
}
